import type { AutoConfiguratorState } from '@snap-types/models/auto-configurator/state';

export function selectLastImportResult(
  state: AutoConfiguratorState,
  siteCode?: string,
) {
  const normalizedSiteCode = (siteCode ?? state.siteCode)?.toLowerCase();

  if (!normalizedSiteCode) {
    return null;
  }

  return state.lastImportResultsBySiteCode[normalizedSiteCode] ?? null;
}
